// Page header for Ballpark, same layout as the other verticals' headers: team logo and title on the
// left, the Overview / Ballpark / Game Day tabs on the right (with a Live pill on today's game).
import React, { useContext } from 'react';
import Icon from '../../../components/atoms/Icon';
import SportIcon from '../../../components/atoms/SportIcon';
import AuthContext from '../../../contexts/auth-context';
import { getUserTeam } from '../../../util';
import BallparkIconBlack from '../../../assets/bp_logo_black.svg';
import BallparkIconWhite from '../../../assets/bp_logo_white.svg';
import '../../Concession/concession.css';

const BallparkHeader = ({
  viewMode,
  setViewMode,
  isToday,
  selectedDate,
}) => {
  const authCtx = useContext(AuthContext);
  const team = getUserTeam(authCtx.league, authCtx.venue);

  const tab = (mode, label, icon) => (
    <button
      type="button"
      role="tab"
      aria-selected={viewMode === mode}
      onClick={() => setViewMode(mode)}
      className={`cx-segmented-btn ${viewMode === mode ? 'active' : ''}`}
    >
      {icon}
      {label}
    </button>
  );

  return (
    <div className="cx-header">
      <div className="cx-header-identity">
        {team?.imgURL && (
          <>
            <img src={team.imgURL} alt="" className="cx-header-logo" style={{ borderRadius: 10 }} />
            <div className="cx-header-divider" />
          </>
        )}
        <div style={{ minWidth: 0 }}>
          <div className="cx-eyebrow">Ballpark</div>
          <h1 className="cx-header-title">Ballpark Analytics</h1>
        </div>
      </div>

      <div className="cx-header-actions">
        {viewMode === 'game' && isToday && selectedDate && (
          <span className="cx-live-pill">
            <span className="pulsing-dot" />
            Live
          </span>
        )}
        <div className="cx-segmented" role="tablist">
          {tab('overview', 'Overview', <Icon name="graph-up" />)}
          {tab('ballpark', 'Ballpark', (
            <img
              src={viewMode === 'ballpark' ? BallparkIconWhite : BallparkIconBlack}
              alt=""
              style={{ width: '1.35em', height: '1.35em', objectFit: 'contain' }}
            />
          ))}
          {tab('game', 'Game Day', <SportIcon fontSize="inherit" />)}
        </div>
      </div>
    </div>
  );
};

export default BallparkHeader;
